import React from "react";
import { useEditTeamMutation } from "../../redux/features/teams/teamsApi";
import { ThreeCircles } from "react-loader-spinner";
import useAuth from "../../hooks/useAuth";

function SingleUser({ user, teamMembers, id, teamCreatror, notify }) {
  const { user: loggedinUser } = useAuth();
  let exisitingMembers = teamMembers.map((m) => m.email);
  const [editTeam, { isLoading }] = useEditTeamMutation();
  const manageUser = async (e) => {
    if (exisitingMembers.includes(user.email) && e.target.name === "member") {
      notify("This user is a member of the team", "success");
    }
    if (!exisitingMembers.includes(user.email) && e.target.name === "assign") {
      if (loggedinUser.email !== teamCreatror.email) {
        notify(
          "You are not the creator of this team,so you cannot assign member.",
          "warn"
        );
      } else {
        try {
          await editTeam({
            id,
            body: {
              teamMembers: [...teamMembers, user],
            },
          }).unwrap();
          notify("Successfully added to the member list", "success");
        } catch (error) {
          notify("Network or server problem", "error");
        }
      }
    }
    if (e.target.name === "creator") {
      notify("This user is the ceator of the team", "success");
    }
    if (exisitingMembers.includes(user.email) && e.target.name === "remove") {
      const newTeamMembers = teamMembers.slice();
      const index = teamMembers.findIndex(
        (members) => members.email === user.email
      );
      newTeamMembers.splice(index, 1);
      if (loggedinUser.email !== teamCreatror.email) {
        notify(
          "You are not the creator of this team,so you cannot remove member.",
          "warn"
        );
      } else {
        try {
          await editTeam({
            id,
            body: {
              teamMembers: newTeamMembers,
            },
          }).unwrap();
          notify("Successfully removed from the member list", "warn");
        } catch (error) {
          notify("Network or server problem", "error");
        }
      }
    }
  };

  return (
    <div className=" flex items-center justify-between bg-white hover:bg-gray-100 px-3 py-1 w-[400px] rounded-lg  ">
      <div className=" flex items-center gap-1">
        <div className="h-10 w-10 flex items-center justify-center rounded-full bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">
          <img
            className="h-8 w-8 rounded-full ring-2 ring-white"
            src={user.userUrl}
            alt={user.name}
          />
        </div>
        <div className="flex flex-col justify-center leading-tight text-xs ">
          <p className="font-semibold">{user.name}</p>
          <p>{user.email}</p>
        </div>
      </div>
      <div>
        {exisitingMembers.includes(user.email) &&
        teamCreatror.email !== user.email ? (
          <>
            <button
              name="remove"
              className="relative bg-red-200 text-red-500 hover:bg-red-300 hover:text-red-600 px-2 py-1 rounded-full text-xs font-semibold active:scale-95 mr-2"
              onClick={manageUser}
            >
              {isLoading ? "Removing" : "Remove"}
              <div className="absolute top-[50%] -translate-y-[50%] -translate-x-[50%] left-[50%]">
                <ThreeCircles
                  height="20"
                  width="20"
                  color="#ef4444"
                  wrapperStyle={{}}
                  wrapperclassName=""
                  visible={isLoading}
                  ariaLabel="three-circles-rotating"
                  outerCircleColor=""
                  innerCircleColor=""
                  middleCircleColor=""
                />
              </div>
            </button>
            <button
              name="member"
              className="bg-green-200 text-green-500 hover:bg-green-300 hover:text-green-600 px-2 py-1 rounded-full text-xs font-semibold active:scale-95"
              onClick={manageUser}
            >
              Member
            </button>
          </>
        ) : exisitingMembers.includes(user.email) &&
          teamCreatror.email === user.email ? (
          <>
            <button
              name="creator"
              className=" bg-cyan-300 text-cyan-600 hover:bg-cyan-400 hover:text-cyan-700 px-2 py-1 rounded-full text-xs font-semibold mr-2"
              onClick={manageUser}
            >
              Creator
            </button>
            <button
              name="member"
              className="bg-green-200 text-green-500 hover:bg-green-300 hover:text-green-600 px-2 py-1 rounded-full text-xs font-semibold active:scale-95"
              onClick={manageUser}
            >
              Member
            </button>
          </>
        ) : (
          <button
            name="assign"
            className="relative bg-violet-200 text-violet-500 hover:bg-violet-300 hover:text-violet-600 px-2 py-1 rounded-full text-xs font-semibold active:scale-95"
            onClick={manageUser}
          >
            {isLoading ? "Assigning" : "Assign"}
            <div className="absolute top-[50%] -translate-y-[50%] -translate-x-[50%] left-[50%]">
              <ThreeCircles
                height="20"
                width="20"
                color="#7c3aed"
                wrapperStyle={{}}
                wrapperclassName=""
                visible={isLoading}
                ariaLabel="three-circles-rotating"
                outerCircleColor=""
                innerCircleColor=""
                middleCircleColor=""
              />
            </div>
          </button>
        )}
      </div>
    </div>
  );
}

export default SingleUser;
